/* jslint browser: true */
'use strict';

import $ from 'jquery';

import { quoteSolr, GraphQueryClient, getUrlParameters } from '../graphq.js';

import 'ol/ol.css';
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import View from 'ol/View';
import Point from 'ol/geom/Point';
import Overlay from 'ol/Overlay';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { Cluster, OSM, Vector as VectorSource } from 'ol/source';
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from 'ol/style';

import {scale as scaleCoordinate, add as addCoordinate} from 'ol/coordinate'; // MyCluster
import {getUid} from 'ol/util';
import {buffer, createEmpty, createOrUpdateFromCoordinate} from 'ol/extent';

class MyCluster extends Cluster {
  constructor (options) {
    super(options);
  }

  createCluster (features) {
    const centroid = [0, 0];
    let n = 0;
    for (let i = features.length - 1; i >= 0; --i) {
      const geometry = this.geometryFunction(features[i]);
      if (geometry) {
        const g = geometry.getCoordinates();
        const count = features[i].getProperties()._count;
        g[0] *= count;
        g[1] *= count;
        addCoordinate(centroid, g); // hier entspr. _count, +Zähler
        n += count;
      } else {
        features.splice(i, 1);
      }
    }
    scaleCoordinate(centroid, 1 / n); // div Zähler statt div features.length

    const cluster = new Feature(new Point(centroid));
    cluster.set('features', features);
    return cluster;
  }

  cluster () {
    if (this.resolution === undefined) {
      return;
    }
    this.features.length = 0;
    const extent = createEmpty();
    const mapDistance = this.distance * this.resolution;
    const features = this.source.getFeatures();

    /**
     * @type {!Object<string, boolean>}
     */
    const clustered = {};

    for (let i = 0, ii = features.length; i < ii; i++) {
      const feature = features[i];
      if (!(getUid(feature) in clustered)) {
        const geometry = this.geometryFunction(feature);
        if (geometry) {
          const featureExtentClass = feature.getProperties().extentClass;
          const coordinates = geometry.getCoordinates();
          createOrUpdateFromCoordinate(coordinates, extent);
          buffer(extent, mapDistance, extent);

          let neighbors = this.source.getFeaturesInExtent(extent);
          neighbors = neighbors.filter(function (neighbor) {
            const uid = getUid(neighbor);
            if (!(uid in clustered) && featureExtentClass === neighbor.getProperties().extentClass) {
              clustered[uid] = true;
              return true;
            } else {
              return false;
            }
          });
          this.features.push(this.createCluster(neighbors));
        }
      }
    }
  }
}

class MapClient {
  constructor () {
    this.classi = undefined;
    this.fq = [];
    this.result = undefined;

    this.gqc = {};
    this.gqc.form = $('#graphq-form');
    this.gqc.result = $('#graphq-result');
    this.gqc.result_facet = $('#graphq-result-facet');
    this.gqc.buttons2 = $('#graphq-buttons2');
    this.center = [0, 0];
    this.zoom = 2;
    this.autoFit = true;

    this.treeq_cgi = '/Suchindex/cgi-bin/treeq.cgi';
    this.data = undefined;
    this.ui_lang = 'ger';
    this.debug = false;
  }

  buildMap () {
    var features = [];
    Object.values(this.data._hlDocById).forEach(v => {
      if (typeof v._count === 'undefined') return;
      if (v._count < 1) return;
      if (typeof v.meta_subject_coordinates_ps === 'undefined') return;
      const latlon = v.meta_subject_coordinates_ps[0].split(/,/);
      var coordinates = ol.proj.fromLonLat([latlon[1], latlon[0]]);
      const feature = new Feature(new Point(coordinates));

      /*
        A country, state, region,...
        H stream, lake, ...
        L parks,area, ...
        P city, village,...
        R road, railroad
        S spot, building, farm
        T mountain,hill,rock,...
        U undersea
        V forest,heath,... */
      const f = v.geonames_fcl_s + '.' + v.geonames_fco_s;
      let extentClass = 2; // 1 == kleine, 2 == große Ausdehnung
      if (v.geonames_fcl_s === 'P' || v.geonames_fcl_s === 'S') extentClass = 1;
      if (v.geonames_fcl_s === 'A' && v.geonames_fco_s.substr(0, 3) !== 'PCL' && v.geonames_fco_s.substr(0, 4) !== 'ADM1') extentClass = 1;
      if (f === 'T.HLL' || f === 'T.ISL') extentClass = 1; // Hügel + Insel = klein
      feature.setProperties({ id: v.id, extentClass: extentClass, meta_subject_txt: v.meta_subject_txt[0], geonames_fcl_s: v.geonames_fcl_s, geonames_fco_s: v.geonames_fco_s, _count: v._count }, true);
      // feature.setStyle(new Style("#ff0000"));
      features.push(feature);
    });
    console.log(features.length + ' features.');

    var distance = document.getElementById('distance');

    var source = new VectorSource({
      features: features
    });

    var clusterSource = new MyCluster({
      distance: parseInt(distance.value, 10),
      geometryFunction: function (feature) {
        // When a feature should not be considered for clustering, the function should return null
        // ja... aber dann tauchen die gar nicht mehr auf!
        return feature.getGeometry();
        /* const prop = feature.getProperties();
        /*
          A country, state, region,...
          H stream, lake, ...
          L parks,area, ...
          P city, village,...
          R road, railroad
          S spot, building, farm
          T mountain,hill,rock,...
          U undersea
          V forest,heath,... * /
        if (prop.geonames_fco_s.substring(0, 3) === 'PCL') return null;
        if (prop.geonames_fco_s.substring(0, 4) === 'ADM1') return null;
        if (prop.geonames_fcl_s === 'P' || prop.geonames_fcl_s === 'S') return feature.getGeometry();
        if (prop.geonames_fcl_s === 'A') return feature.getGeometry();
        return null; */
      },
      source: source
    });

    function circleRadius (number) {
      const digits = Math.floor(Math.log10(number)) + 1;
      const aspect = 1638 / 1139; // Arial Ziffer, höhe/breite
      const x = digits / 2;
      const y = aspect / 2;
      return Math.sqrt(x * x + y * y);
    }

    var clusters = new VectorLayer({
      source: clusterSource,
      style: function (feature) {
        let sumCountMeta = 0;
        let extentClass = 0;
        feature.get('features').forEach(sf => {
          sumCountMeta += sf.getProperties()._count;
          extentClass = sf.getProperties().extentClass; // eindeutig je Cluster
        });
        var style = new Style({
          image: new CircleStyle({
            radius: 2 + 7 * circleRadius(sumCountMeta),
            fill: new Fill({
              color: [0xff, 0, (extentClass - 1) * 0xff, 0.5]
            })
          }),
          text: new Text({
            text: sumCountMeta.toString(),
            offsetY: 1,
            fill: new Fill({
              color: '#000'
            })
          })
        });
        return style;
      }
    });

    var raster = new TileLayer({
      source: new OSM({url: "https://{a-c}.tile.openstreetmap.de/{z}/{x}/{y}.png"}) // 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    });

    var map = new Map({
      layers: [raster, clusters],
      target: 'map',
      view: new View({
        center: ol.proj.fromLonLat(this.center),
        zoom: this.zoom 
      })
    });
    console.log(`this.center = ${this.center}`);
    if (this.autoFit) map.getView().fit(source.getExtent(), {maxZoom:17, padding:[20,20,20,20]});

    var tooltip = document.getElementById('tooltip');
    var ttOverlay = new ol.Overlay({
      element: tooltip,
      offset: [10, 10],
      positioning: 'top-left'
    });
    map.addOverlay(ttOverlay);

    // https://stackoverflow.com/questions/43004561/how-do-i-add-a-click-event-on-openlayers-4
    map.on('click', (event) => { // nicht »function(event) { …« wg. this.fq
      let qstr = '';
      map.forEachFeatureAtPixel(event.pixel, function (feature, layer) {
        feature.get('features').forEach(sf => {
          qstr = qstr + ' OR parent_ids:' + quoteSolr(sf.getProperties().id);
        });
      });
      qstr = qstr.substring(4); // erstes » OR « am Anfang weg
      if (!qstr.length) return;
      /*
gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.se
  gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.
    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gq
  gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.
gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.se
*/
      const gqc = new GraphQueryClient();
      gqc.rows = typeof this.rows !== 'undefined' ? this.rows : 20;
      gqc.prepareDocOpt.hl = true;
      gqc.form = this.gqc.form;
      gqc.result = this.gqc.result;
      gqc.result_facet = this.gqc.result_facet;
      gqc.buttons2 = this.gqc.buttons2;
      gqc.ui_lang = this.ui_lang; // CAVE: nicht this.gqc.ui_lang
      gqc.facetParameterStr = '&facet=true&facet.mincount=1' +
              '&facet.field=type_s' + // '&facet.field={!ex=type_s}type_s' -- siehe auch graphq.js/getFilterByFacet() -- geht noch nicht - org.apache.solr.search.SyntaxError: Expected identifier at pos 8 str='{!graph !tag=$_tt0 from=$_tt1 v=$_tt2 to=$_tt3 }'
              '&facet.field=meta_name_ss' +
              '&facet.field=meta_periodical_title_s' +
              '&facet.field=meta_subject_ss' +
              '&facet.field=meta_name_aut_firstchar_ss' +
              '&facet.field=meta_language_ss' +
              '&facet.field=parent_ids' +
              '&f.parent_ids.facet.contains=/classification/' +
              '&facet.range=meta_date_dtrs' +
              '&f.meta_date_dtrs.facet.range.start=0000-01-01T00:00:00Z' +
              '&f.meta_date_dtrs.facet.range.end=2100-01-01T00:00:00Z' +
              '&f.meta_date_dtrs.facet.range.gap=%2B1YEAR'; // +1YEAR */
      const rr = gqc.form.find('select[name="resultset_restriction"]');
      rr.empty();
      'auto,higher,lower,none'.split(',').forEach(w => {
        $(`<option value='${w}'>` + gqc.translate(`resultset_restriction|${w}`) + '</option>').appendTo(rr);
      });
      const so = gqc.form.find('select[name="sort"]');
      so.empty();
      'sort_title_s asc,sort_name_s asc,sort_shelflocator_s asc,sort_date_dt asc,score asc'.split(',').forEach(w => {
        $(`<option value='${w}'>` + gqc.translate(`sort|${w}`) + '</option>').appendTo(so);
      });
      const qfo = gqc.form.find('select[name="qf"]');
      qfo.empty();
      ',m,meta_title_txt,meta_name_txt,meta_name_aut_txt,meta_subject_txt,meta_classification_txt,meta_shelflocator_txt,t'.split(',').forEach(w => {
        $(`<option value='${w}'>` + gqc.translate(`qf|${w}`) + '</option>').appendTo(qfo); // befüllt tatsächlich alle qfo's
      });
      gqc.form.find('input[name="q"]')[0].value = qstr;
      if (Array.isArray(this.fq) && typeof this.fq[0] !== 'undefined') gqc.form.find('input[name="fq"]')[0].value = this.fq[0]; // TODO: nur 1 fq aus urlParameter übernommen
      gqc.form.find('select[name="resultset_restriction"]').val('none');
      gqc.formQuery();
      /*
    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gq
  gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.
gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.se
  gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.
    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gqc.setupForm()    gq
*/
    });

    map.on('pointermove', function (event) {
      let subj = [];
      map.forEachFeatureAtPixel(event.pixel, function (feature, layer) {
        feature.get('features').forEach(sf => {
          subj.push([sf.getProperties().meta_subject_txt, sf.getProperties()._count]);
        });
      });
      if (!subj.length) {
        tooltip.style.display = 'none';
        // tooltip.innerHTML = '';
        return;
      }
      subj = subj.sort((a, b) => {
        if (a[1] < b[1]) return 1;
        if (a[1] > b[1]) return -1;
        return 0;
      });
      ttOverlay.setPosition(event.coordinate);

      let html = '';
      for (let i = 0; i < 50 && i < subj.length; i++) {
        html += `, ${subj[i][0]}<sup>${subj[i][1]}</sup>`;
      }
      html = html.substring(2); // ", " am Anfang weg
      tooltip.innerHTML = html;
      tooltip.style.display = 'block';
    });

    // Schieberegler
    distance.addEventListener('input', function () {
      clusterSource.setDistance(parseInt(distance.value, 10));
    });
  }

  updateStatus (treeq_cgi, cgiParam, waitDiv) {
    $.ajax(treeq_cgi + '?' + cgiParam.join('&') + '&getStatus=1', {
      dataType: 'text',
      success: data => {
        waitDiv.textContent = data;
      }
    });
  }

  run () {
    const waitDiv = document.createElement('div');
    waitDiv.textContent = 'please wait...';
    this.result.appendChild(waitDiv);

    const cgiParam = [];
    cgiParam.push('classification=' + encodeURIComponent(this.classi));
    this.fq.map(x => cgiParam.push('fq=' + encodeURIComponent(x)));

    const us = setInterval(this.updateStatus, 1000, this.treeq_cgi, cgiParam, waitDiv);

    $.ajax(this.treeq_cgi + '?' + cgiParam.join('&'), {
      dataType: 'json',
      success: data => {
        clearInterval(us);
        this.result.removeChild(waitDiv);

        this.data = data;
        // this.gqc.data = data;
        this.buildMap();
      },
      error: (jqXHR, textStatus, errorThrown) => {
        clearInterval(us);
        this.result.removeChild(waitDiv);

        console.log('error: ', errorThrown);
      }
    });
  }
}

export { MapClient };
